// When added to any wrapping element, the block will
// fade into view as the user scrolls down the page
const reveal = {
  inViewport(el) {
    const rect = el.getBoundingClientRect();
    return !(
      rect.bottom < 0 ||
      rect.right < 0 ||
      rect.left > window.innerWidth ||
      rect.top > window.innerHeight - 50
    );
  },

  bind(el, binding) {
    el.classList.add("v-reveal");
    el.classList.add("before-enter");
    el.$onScroll = () => {
      if (binding.def.inViewport(el)) {
        setTimeout(() => {
          el.classList.add("enter");
          el.classList.remove("before-enter");
          binding.def.unbind(el, binding);
        }, 200);
      }
    };
    document.addEventListener("scroll", el.$onScroll);
  },

  inserted(el) {
    el.$onScroll();
  },

  unbind(el) {
    document.removeEventListener("scroll", el.$onScroll);
    delete el.$onScroll;
  }
};

export { reveal as default };
